import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Images from "assets/images/imageData";
import "./style.css";

const Loader = ({ isLoading = false }) => {
  return (
    <Fragment>
      {isLoading && (
        <div className="loader-wrapper">
          <img
            className="loader-img"
            src={Images?.loader}
            alt="Loading..."
          />
        </div>
      )}
    </Fragment>
  );
};

Loader.propTypes = {
  isLoading: PropTypes.bool,
};

export default Loader;
